import React, { useEffect, useState, useContext } from "react";
import { Building, FloorOverlay } from "generated/graphql";
import firebase from "../../Firebase/firebase";
import "firebase/firestore";
import { getGoogleMaps } from "config/GoogleMaps";
import { isNullableType } from "graphql";
import { AuthContext } from "Firebase/AuthProvider";
import { BuildingContext } from "Context/BuildingProvider";
import { OnlineBuildingGuard, LastLocation } from "lib/realtimeDBTypes";
import InfoWindowEx from "Modules/LiveScreen/InfoWindowEx";
import ReactDOM from "react-dom";

export interface MarkerListMapProps {
  floorOverlays: Pick<
    FloorOverlay,
    | "BuildingId"
    | "CenterLat"
    | "CenterLng"
    | "D_diff"
    | "FloorNumber"
    | "Id"
    | "ImageUrl"
    | "Name"
    | "Rot"
    | "created_at"
    | "k_diff"
    | "updated_at"
  >[];
  mapId: string;
  markers: MarkerObject[];
}

//export type MarkerObject = google.maps.Marker & { id: string };
export interface MarkerObject extends google.maps.Marker {
  id?: string;
}

interface MarkerListMapState {
  currentFloorNumber: number;
  //@ts-ignore
  currentLocation?: { lat: number; lng: number };
  //@ts-ignore
  map?: google.maps.Map;
}
const DEFAULT_STATE: MarkerListMapState = {
  currentFloorNumber: 0,
  map: undefined,
};
//@ts-ignore
let map: any;
export default function MarkerListMap({
  floorOverlays,
  mapId,
  markers,
}: MarkerListMapProps) {
  const { getImageUrl, getDatabase } = useContext(AuthContext);
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const [state, setState] = useState(DEFAULT_STATE);
  //@ts-ignore
  var overlay: google.maps.OverlayView;
  //@ts-ignore
  var loc_center: google.maps.LatLng;
  var CenterLat: number;
  var CenterLng: number;
  var k_diff: number = 0.005;
  var D_diff: number = 0.01;
  var rot: number = 0;

  const initMap = async (mapId: string) => {
    loc_center = new google.maps.LatLng(
      currentBuilding!.centerLat,
      currentBuilding!.centerLong
    );
    let url = "";
    if (!!getImageUrl) {
      url = await getImageUrl(
        "overlays",
        currentBuilding?.Id +
          "/" +
          floorOverlays[state.currentFloorNumber].Id +
          ".jpg"
      );
    }
    class DebugOverlay extends google.maps.OverlayView {
      //@ts-ignore
      map_?: google.maps.Map;
      opacity?: number;
      //@ts-ignore
      private bounds: google.maps.LatLngBounds;
      private image: string;
      private div?: HTMLElement;
      //@ts-ignore
      constructor(bounds: google.maps.LatLngBounds, image: any) {
        super();
        this.bounds = bounds;
        this.image = image;
      }

      onAdd() {
        this.div = document.createElement("div");
        this.div.style.borderStyle = "none";
        this.div.style.borderWidth = "0px";
        this.div.style.position = "absolute";
        this.div.style.visibility = "visible";
        var img = document.createElement("img");
        img.src = this.image;
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.opacity = "1";
        img.style.position = "absolute";
        img.style.transform = "rotate(" + rot + "rad)";
        this.div.appendChild(img);
        //@ts-ignore
        var panes = this.getPanes();
        panes.overlayLayer.appendChild(this.div);
      }

      draw() {
        //@ts-ignore
        var overlayProjection = this.getProjection();
        var sw = overlayProjection.fromLatLngToDivPixel(
          this.bounds!.getSouthWest()
        );
        var ne = overlayProjection.fromLatLngToDivPixel(
          this.bounds!.getNorthEast()
        );
        var div = this.div;
        div!.style.left = sw.x + "px";
        div!.style.top = ne.y + "px";
        div!.style.width = ne.x - sw.x + "px";
        div!.style.height = sw.y - ne.y + "px";
        div!.style.transform = "rotate(" + rot + "deg)";
      }

      onRemove() {
        this?.div?.parentNode?.removeChild(this.div);
        delete this.div;
      }
    }
    const mapElement = document.getElementById(mapId);
    var mapOptions = {
      zoom: 18,
      center: loc_center,
      backgroundColor: "#051932",
      disableDefaultUI: true,
    };
    //@ts-ignore
    let waypointMarker: window.google.maps.Marker;
    const placeMarker = (location: { lat: number; lng: number }) => {
      if (waypointMarker == null) {
        //@ts-ignore
        waypointMarker = new window.google.maps.Marker({
          //@ts-ignore
          position: new window.google.maps.LatLng(location.lat, location.lng),
          map: map,
        });
      } else {
        //@ts-ignore
        waypointMarker.setPosition(
          //@ts-ignore
          new window.google.maps.LatLng(location.lat, location.lng)
        );
      }
    };

    let initialize = () => {
      const customStyled = [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ];
      map.set("styles", customStyled);
      //@ts-ignore
      var newPointA = new window.google.maps.LatLng(
        CenterLat - k_diff,
        CenterLng - D_diff
      );
      //@ts-ignore
      var newPointB = new window.google.maps.LatLng(
        CenterLat + k_diff,
        CenterLng + D_diff
      );
      //@ts-ignore
      var bounds = new window.google.maps.LatLngBounds(newPointA, newPointB);
      var srcImage = url; //"https://res.cloudinary.com/dx8nclins/image/upload/v1569765645/buildings/fb10989e-942e-4142-8687-e7e903b03cef.png";

      overlay = new DebugOverlay(bounds, srcImage);
      overlay.setMap(map);
      //@ts-ignore

      const floorChange = async (controlDiv: HTMLElement): Promise<any> => {
        var controlUI = document.createElement("div");
        controlUI.style.backgroundColor = "#fff";
        controlUI.style.marginRight = "5px";
        controlUI.style.border = "2px solid #fff";
        controlUI.style.borderRadius = "3px";
        controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI.style.cursor = "pointer";
        controlUI.style.marginBottom = "22px";
        controlUI.style.textAlign = "center";
        controlDiv.appendChild(controlUI);

        var controlText = document.createElement("div");
        controlText.style.color = "rgb(25,25,25)";
        controlText.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText.style.fontSize = "16px";
        controlText.style.lineHeight = "38px";
        controlText.style.paddingLeft = "5px";
        controlText.style.paddingRight = "5px";
        controlText.innerHTML = "Floor Up";
        controlUI.appendChild(controlText);

        controlUI.addEventListener("click", async () => {
          if (state.currentFloorNumber === floorOverlays.length - 1) {
            console.log("highest floor");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[state.currentFloorNumber + 1];
            const newCurrentFloorNumber = state.currentFloorNumber + 1;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id +
                  "/" +
                newCurrentFloor.Id +
                  ".jpg"
              );
            }
            var srcImage = url;

            //@ts-ignore
            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );
            //@ts-ignore
            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );
            //@ts-ignore
            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map)
            /* eslint-disable */

            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
          }
        });

        var controlUI2 = document.createElement("div");
        controlUI2.style.backgroundColor = "#fff";
        controlUI2.style.marginRight = "5px";
        controlUI2.style.border = "2px solid #fff";
        controlUI2.style.borderRadius = "3px";
        controlUI2.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI2.style.cursor = "pointer";
        controlUI2.style.marginBottom = "22px";
        controlUI2.style.textAlign = "center";
        controlDiv.appendChild(controlUI2);

        var controlText2 = document.createElement("div");
        controlText2.style.color = "rgb(25,25,25)";
        controlText2.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText2.style.fontSize = "16px";
        controlText2.style.lineHeight = "38px";
        controlText2.style.paddingLeft = "5px";
        controlText2.style.paddingRight = "5px";
        controlText2.innerHTML = "Floor Down";
        controlUI2.appendChild(controlText2);

        controlUI2.addEventListener("click", async () => {
          console.log("floor down");

          if (state.currentFloorNumber === 0) {
            console.log("lowest floor");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[state.currentFloorNumber - 1];
            const newCurrentFloorNumber = state.currentFloorNumber + 1;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id +
                  "/" +
                newCurrentFloor.Id +
                  ".jpg"
              );
            }
            var srcImage = url;
            //@ts-ignore
            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );
            //@ts-ignore
            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );
            //@ts-ignore
            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map)
            /* eslint-disable */

            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
          }
        });
      };

      var floorControlDiv = document.createElement("div");
      floorChange(floorControlDiv);
      //@ts-ignore
      map.controls[window.google.maps.ControlPosition.RIGHT_CENTER].push(
        floorControlDiv
      );
      setState({ ...state, map: map });
    };

    if (!!mapElement) {
      //@ts-ignore
      map = new google.maps.Map(mapElement, mapOptions);
      initialize();
      markers.forEach((marker: google.maps.Marker) => {
        marker.setMap(map);
      });
    } else {
      console.log("no map element");
    }
  };

  useEffect(() => {
    let googleMapPromise = getGoogleMaps();
    CenterLat = currentBuilding?.centerLat;
    CenterLng = currentBuilding?.centerLong;
    k_diff = floorOverlays[state.currentFloorNumber].k_diff;
    D_diff = floorOverlays[state.currentFloorNumber].D_diff;
    rot = floorOverlays[state.currentFloorNumber].Rot;
    if (!window.google) {
      Promise.all([googleMapPromise]).then((values) => {
        let google = values[0];

        initMap(mapId);
      });
    } else {
      initMap(mapId);
    }
  }, []);

  const styles = {
    container: {
      height: "70vh",
      width: "100%",
      //display: 'flex',
      //flexDirection: 'column',
    },
  };
  return <div id={mapId} style={styles.container} />;
}
